import React from "react";
import { Menu, ActionIcon } from "@mantine/core";
import {
  IconDotsVertical,
  IconChecks,
  IconSquareMinus,
} from "@tabler/icons-react";

interface Props {
  onMarkAll: () => void;
  onClearAll: () => void;
  disabled?: boolean;
}

export const BulkMarkReceivedCompletedAction: React.FC<Props> = ({
  onMarkAll,
  onClearAll,
  disabled,
}) => {
  return (
    <Menu withinPortal position="bottom-end" shadow="sm">
      <Menu.Target>
        <ActionIcon variant="subtle" disabled={disabled}>
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item leftSection={<IconChecks size={14} />} onClick={onMarkAll}>
          Mark All Pre-processed
        </Menu.Item>
        <Menu.Item
          leftSection={<IconSquareMinus size={14} />}
          onClick={onClearAll}
          color="red"
        >
          Clear All
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
